module.exports = __webpack_public_path__ + "integration--8f5454c9.svg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/integration/integration.svg
// module id = 178
// module chunks = 0